import React from 'react'

const withState = WrappedComponent => {
  return props => {
    const [form, setForm] = React.useState({
      locationId: '',
      familySize: '',
      adjustedGrossIncome: '',
      specialCircumstances: ''
    })

    const [approved, setApproved] = React.useState(false)
    const [discountAmount, setDiscountAmount] = React.useState(null)

    return (
      <WrappedComponent
        form={form}
        setForm={setForm}
        approved={approved}
        setApproved={setApproved}
        discountAmount={discountAmount}
        setDiscountAmount={setDiscountAmount}
        {...props}
      />
    )
  }
}

export default withState
